import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, EmailMediaLibraryDisplayItem, EmailMediaLibraryInputItem, EmailMediaLibraryItemSearchOptions, EmailMediaLibraryUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace EmailMediaLibraryRoutes {
    export const Get = ApiRoute.Define({
        URL: (emailMediaLibraryItemID: string) => `emailmedialibrary/${emailMediaLibraryItemID}`,
        Kind: RequestKind.Get,
        ResultType: EmailMediaLibraryDisplayItem
    });

    export const Search = ApiRoute.Define({
        URL: `search/emailmedialibrary`,
        Kind: RequestKind.Post,
        BodyType: EmailMediaLibraryItemSearchOptions,
        ResultType: DisplayItemCollection<EmailMediaLibraryDisplayItem>,
        PagingAllowed: true
    });

    export const Add = ApiRoute.Define({
        URL: `emailmedialibrary`,
        Kind: RequestKind.Post,
        BodyType: EmailMediaLibraryInputItem,
        ResultType: string
    });

    export const Update = ApiRoute.Define({
        URL: (emailMediaLibraryItemID: string) => `emailmedialibrary/${emailMediaLibraryItemID}`,
        Kind: RequestKind.Put,
        BodyType: EmailMediaLibraryUpdateItem,
        ResultType: boolean
    });

    export const Delete = ApiRoute.Define({
        URL: (emailMediaLibraryItemID: string) => `emailmedialibrary/${emailMediaLibraryItemID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });
}
